__turbopack_context__.v({
  "container": "yxXUrq_container",
  "list": "yxXUrq_list",
  "stat": "yxXUrq_stat",
  "statDescription": "yxXUrq_statDescription",
  "statSubject": "yxXUrq_statSubject",
});
